import { createAction } from '@reduxjs/toolkit';

import { SmartReplyResponsePayloadV2 } from '../components/SmartConversationReplyButton/useSmartReplyResponse';

const prefix = `elevio/smartReplyResponse`;

export const smartReplyActions = {
  smartReplyRequested: createAction(`${prefix}/smartReplyRequested`),
  smartReplyResponseReceived: createAction<{
    data: Pick<SmartReplyResponsePayloadV2, 'response'>;
  }>(`${prefix}/smartReplyResponseReceived`),
  smartReplyResponseError: createAction(`${prefix}/smartReplyResponseError`),
  smartReplyFinally: createAction(`${prefix}/smartReplyFinally`),
  updateReplySectionTabStatus: createAction<{ tabStatus: 'reply' | 'note' }>(
    `${prefix}/updateReplySectionTabStatus`,
  ),
};
